import React from 'react';
import { useTranslation } from 'react-i18next';
import { AUDIO_EFFECTS_URL } from '@src/configs';

import { Typography } from '@mui/material';
import { TuneRounded } from '@mui/icons-material';
import { StyledTextIcon } from './index.style';
import { StyledIconButton } from '../NewRequest/index.style';

const EffectGuideButton = ({
  hasDisable,
  onClick,
  audioLink,
  langEng,
  requestId,
}) => {
  const { t } = useTranslation();

  const handleOpenAudioEffects = async () => {
    onClick();
    window.open(`${AUDIO_EFFECTS_URL}/?audio=${audioLink}`, '_blank');
  };

  return (
    <StyledTextIcon
      disableRipple
      onClick={handleOpenAudioEffects}
      disabled={hasDisable}
      langEng={langEng}
      data-id="add-effect-curr-req-audio"
      data-request-id={requestId}
    >
      <StyledIconButton
        isDisableHover
        disabled={hasDisable}
        height="40px"
        width="40px"
        padding="12px"
      >
        <TuneRounded
          style={{ fontSize: '24px' }}
          className={hasDisable ? 'icon-disabled icon' : 'icon'}
        />
      </StyledIconButton>
      <Typography className="text-action">{t('correction')}</Typography>
    </StyledTextIcon>
  );
};

export default EffectGuideButton;
